module.exports = __webpack_public_path__ + "static/animation-award-light-347192efff2ed20c825bd1fcc061f948.png";